import { service } from '@ember/service';
import Helper from '@ember/component/helper';
import prepareOptions from '../utils/prepare-options';
import { dedupeTracked } from 'tracked-toolbox';
import BaseSound from '../../stereo-connections/base';

export default class ActionHelper extends Helper {
  @service stereo;
  identifier = null;
  @dedupeTracked options;
  @dedupeTracked _sound;
  @dedupeTracked foundSound;

  get sound() {
    if (this._sound) {
      return this._sound;
    } else if (this.foundSound?.isResolved) {
      return this.foundSound;
    }

    return null;
  }

  compute([identifier], options = {}) {
    this.options = prepareOptions(options);

    if (identifier !== this.identifier) {
      this.identifier = identifier;
      if (this.identifier instanceof BaseSound) {
        this._sound = this.identifier;
      } else if (this.identifier) {
        this.foundSound = this.stereo.findSound(identifier);
      }

      if (!this.sound) {
        if (options.load) {
          this.stereo.load(this.identifier, this.options);
        }
      }
    }

    return (e) => this.performAction(this.sound, e);
  }

  performAction() {
    return false;
  }
}
